import { defectStatisRequest } from '@/network/requests/defectStatis'
import { FilterQuery } from '@/network/interfaces/FilterQuery'
import dictionaryData from './dictionaryData'
import { productRequest } from '@/network/requests/product'
import { formatDate } from '@/util/datetime'
import { job_order } from '@/interfaces/job_order'
import { jobOrderRequest } from '@/network/requests/jobOrder'
import { jt_info } from '@/interfaces/jt_info'
import { jtInfoRequest } from '@/network/requests/jtInfo'
import { getDefectRequest } from '@/network/requests/defect'
import { defectTypeRequest } from '@/network/requests/defectType'
import { $in } from '@/network/util/QueryBuilder'
import { SortQuery } from '@/network/interfaces/SortQuery'

/**
 * 获取批次状态信息：
 * 0-正在检测，1-正在上传，2-上传完成
 * @param val
 */
var getDefectStatusText = val => {
	var text = '--'
	switch (val) {
		case 0:
			text = '正在检测'
			break
		case 1:
			text = '正在上传'
			break
		case 2:
			text = '上传完成'
			break
	}

	return text
}

/**
 * 获取筛选状态。
 * 0-未筛选，1-正在筛选，2-筛选完成
 * @param val
 */
var getFilterStatusText = val => {
	var text = '--'
	switch (val) {
		case 0:
			text = '未筛选'
			break
		case 1:
			text = '正在筛选'
			break
		case 2:
			text = '筛选完成'
			break
		default:
			text = '其他'
			break
	}

	return text
}

/**
 * 批次列表查询。
 * @param page
 * @param pageSize
 * @param filter
 * @param sort
 */
var getDefectStatList = async (page: number, pageSize: number, filter: FilterQuery | undefined, sort: SortQuery | undefined) => {
	var jtList = await dictionaryData.getJTList()
	//车间查询。
	if (filter?.workshop_id) {
		var jt_id_array = jtList.filter(t => t.workshop == filter?.workshop_id).map(t => t.value)
		filter.jt_id = { $in: jt_id_array }

		delete filter.workshop_id
	}

	//查询批次
	var listData = (await defectStatisRequest.queryPage({ pagesize: pageSize, page, filter, sort })).data

	var product_id_array = listData._embedded
		.filter(t => t.product_id)
		.map(t => ({
			$oid: t.product_id,
		}))

	var job_order_id_array = listData._embedded
		.filter(t => t.job_order_id)
		.map(t => ({
			$oid: t.job_order_id,
		}))

	//查询所有产品。
	var products = await productRequest.queryAll({ _id: { $in: product_id_array } })
	//查询批次关联的所有工单。
	var jobOrders = await jobOrderRequest.queryAll({ _id: { $in: job_order_id_array } })

	var result: any = []
	listData._embedded.forEach(async (v, i) => {
		var productName: string | undefined = ''
		if (v.product_id) {
			productName = products.find(t => t._id?.$oid == v.product_id)?.name
		}

		var jobOrder: job_order | undefined = {}
		if (v.job_order_id) {
			jobOrder = jobOrders.find(t => t._id?.$oid == v.job_order_id)
		}

		var jt = jtList.find(t => t.value == v.jt_id)
		console.log('jt', jt, v)

		result.push({
			...v,
			jt_name: jt?.label,
			product_name: productName,
			begin_time_str: formatDate(v.begin_time!),
			end_time_str: formatDate(v.end_time!),
			jobOrder: jobOrder,
			jobOrderCode: jobOrder?.code,
			statusText: getDefectStatusText(v.status),
			filterStatusText: getFilterStatusText(v.filter_status),
		})
	})

	return {
		data: result,
		totalCount: listData._size,
		totalPage: listData._total_pages,
	}
}

var getDefectStat = async (defect_statis_id: string) => {
	var defect_statis = await defectStatisRequest.getDocumentById(defect_statis_id)
}

/**
 *
 * @param page
 * @param pageSize
 * @param jobOrder
 */
var getDefectStatByOrderId = async (page: number, pageSize: number, jobOrder?: job_order) => {
	var v = jobOrder
	var filter
	if (v) {
		filter = {
			job_order_id: v._id,
		}
	}

	var listData = (
		await defectStatisRequest.queryPage({
			page: page,
			pagesize: pageSize,
			filter: filter,
		})
	).data
	console.log('listData')
	console.log(listData)
	var jtList = await dictionaryData.getJTList()

	var result: any = []
	listData._embedded.forEach(async (v, i) => {
		var productName = ''
		if (v.product_id) {
			try {
				var p = (await productRequest.getDocumentById(v.product_id)).data
				productName = p.name
			} catch (error) {
				console.error(error)
			}
		}

		var jt = jtList.find(t => t.value == v.jt_id)
		result.push({
			...v,
			jt_name: jt?.label,
			product_name: productName,
			begin_time_str: formatDate(v.begin_time!),
			end_time_str: formatDate(v.end_time!),
			// jobOrder: jobOrder,
			// jobOrderCode: jobOrder.code,
		})
	})

	return {
		data: result,
		totalCount: listData._size,
		totalPage: listData._total_pages,
	}
}

/**
 * 对某个批次进行缺陷统计。
 * @param defect_statis_id
 * @param loadingCallback
 */
var getDefectStatByStatisIdAsync = async (defect_statis_id: string, loadingCallback?: Function) => {
	//1、查询批次信息。
	var defect_statis = await (await defectStatisRequest.getDocumentById(defect_statis_id)).data
	//2、根据批次查询机台信息。

	var jtInfo: jt_info = {}
	try {
		jtInfo = await (await jtInfoRequest.getDocumentById(defect_statis.jt_id)).data
	} catch (error) {
		console.error(error)
	}

	var defectRequest = getDefectRequest(defect_statis_id)
	var result: any[] = []

	var stat_item: any = {}
	try {
		if (loadingCallback) loadingCallback('正在获取所有所有缺陷记录')
		//获取所有的缺陷记录。
		var array = await defectRequest.queryAll({ status: 0 }, { type_index: 1 }, undefined, 1000)

		//获取所有的缺陷类型。
		var defectTypes = await defectTypeRequest.queryAll({ roll_id: defect_statis_id }, { display: 1, type_index: 1 }, undefined, 1000)
		if (loadingCallback) loadingCallback('正在进行数据统计')

		for (var v of array) {
			//获取缺陷类型。
			var typeName = defectTypes.find(t => t.type_index == v.type_index)?.display
			if (!typeName) continue

			if (typeName in stat_item) {
				stat_item[typeName] += 1
			} else {
				stat_item[typeName] = 1
			}
		}

		if (loadingCallback) loadingCallback('')
	} catch (error) {
		console.error(error)
		if (loadingCallback) loadingCallback('错误' + error)
	}
	stat_item.jt_name = jtInfo?.name
	stat_item.jt_id = defect_statis.jt_id
	result.push(stat_item)

	return result
}

/**
 * 获取某个工单的缺陷信息统计。
 * @param job_order_id
 */
var getDefectStatByJobOrderIdAsync = async (job_order_id: string) => {
	//获取
}

/**
 * 查询某个批次的所有关联的机台。
 * @param defect_statis_id
 */
var getJtListByDefectStatId = (defect_statis_id: string) => {
	//defectStatisRequest.query
}

export default {
	getDefectStatList,
	getDefectStatusText,
	getFilterStatusText,
	getDefectStatByStatisIdAsync,
	getDefectStatByOrderId,
}
